/* ============================================================
   AMORATI — Quick View gallery image loader
   ------------------------------------------------------------
   WHY THIS EXISTS (separate from the custom.css positioning fix):
   Quick View opens the gallery to the selected variant's featured
   media, which is a loading="lazy" image. Inside a Flickity carousel,
   slides are revealed via a CSS transform — and native lazy-loading
   does NOT fire for transform-revealed slides. So every slide except
   the eager first image stays blank, and navigating arrows/thumbnails
   doesn't load them either.

   This is STOCK Cosmo behaviour (confirmed with custom.css fully
   disabled), surfaced because Amorati products open Quick View on a
   later media index rather than the first/eager image. CSS cannot fix
   it (you can't change a loading attribute in CSS), so it needs JS.

   WHAT IT DOES: when a Quick View opens, eager-load its gallery and
   thumbnail images so the variant image appears immediately and every
   thumbnail / arrow target is ready to display.

   INSTALL: add this file as a theme asset, then reference it once near
   the end of layout/theme.liquid:
     <script src="{{ 'quickview-image-load-fix.js' | asset_url }}" defer></script>
   (Or paste the IIFE below inline before </body>.)

   Verified live on the dev store (desktop), Jun 2026: main image shows
   on open + thumbnail navigation switches images correctly.
   ============================================================ */
(function () {
  function forceLoad(scope) {
    var imgs = scope.querySelectorAll(
      '.f-product__media-list img, .f-product__media-thumbnails img'
    );
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.loading === 'lazy' || !img.complete || !img.naturalWidth) {
        img.loading = 'eager';
        img.setAttribute('fetchpriority', 'high');
        var src = img.getAttribute('src');
        if (src) img.setAttribute('src', src); // re-assign to kick the fetch
      }
    });
  }

  function handle(qv) {
    forceLoad(qv);
    // gallery images are injected a beat after the dialog opens; retry briefly
    setTimeout(function () { forceLoad(qv); }, 400);
    setTimeout(function () { forceLoad(qv); }, 1000);
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        var qv = (n.matches && n.matches('.f-product-quickview'))
          ? n
          : (n.querySelector && n.querySelector('.f-product-quickview'));
        if (qv) handle(qv);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();